"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// src/data/Products_0.ts
const product_types_1 = require("../types/product.types");
const products = [
    // Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M2] (Dimarts i dijous 16:00 - 21 h, Desembre - Gener)
    {
        id: 607,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "2025-open-me-curs-presencial-mossos-24-25-m2-40h",
        title: "Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M2] (Dimarts i dijous 16:00 - 21 h, Desembre - Gener)",
        name: "Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M2] (Dimarts i dijous 16:00 - 21 h, Desembre - Gener)",
        description: "Reserva la teva plaça per al curs intensiu Mossos d'Esquadra (40 hores), dimarts i dijous de desembre i gener de 16:00 a 21:00 h!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 349.99,
        // offer: 349.99,
        // offer_text: "Promoció Mossos només durant 24 hores!",
        shipment: 0.0,
        images: ["/607/image1"],
        banner: ["/607/image1"],
        link: "/tienda/cursos/curs-presencial-mossos-esquadra-2024-25-m2-40h/",
        created_at: "2024-09-19 00:00:01",
        start_at: "2024-09-19 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 26,
        evolmind: { course_id: 349, group_id: [1995] },
    },
    // Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M3] (Dissabtes i diumenges 16:00 - 21 h, Desembre - Gener)
    {
        id: 608,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "2025-open-me-curs-presencial-mossos-24-25-m3-40h",
        title: "Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M3] (Dissabtes i diumenges 16:00 - 21 h, Desembre - Gener)",
        name: "Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M3] (Dissabtes i diumenges 16:00 - 21 h, Desembre - Gener)",
        description: "Reserva la teva plaça per al curs intensiu Mossos d'Esquadra (40 hores), dissabtes i diumenges de desembre i gener de 16:00 a 21:00 h!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 349.99,
        // offer: 349.99,
        // offer_text: "Promoció Mossos només durant 24 hores!",
        shipment: 0.0,
        images: ["/608/image1"],
        banner: ["/608/image1"],
        link: "/tienda/cursos/curs-presencial-mossos-esquadra-2024-25-m3-40h/",
        created_at: "2024-09-19 00:00:02",
        start_at: "2024-09-19 00:00:02",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 28,
        evolmind: { course_id: 349, group_id: [1998] },
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (3 novembre)
    {
        id: 609,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2024-3-nov",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (3 novembre)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (3 novembre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 3 de novembre a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/609/image1"],
        banner: ["/609/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2024-3-novembre/",
        created_at: "2024-09-24 00:00:00",
        start_at: "2024-09-24 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [2001] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (23 novembre)
    {
        id: 610,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2024-23-nov",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (23 novembre)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (23 novembre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 23 de novembre a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/610/image1"],
        banner: ["/610/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2024-23-novembre/",
        created_at: "2024-09-25 00:00:00",
        start_at: "2024-09-25 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 33,
        evolmind: { course_id: 355, group_id: [2004] },
        can_be_sent: false,
        items: 1,
    },
    // Dossier Esquematitzat Mossos d'Esquadra 2025
    {
        id: 611,
        tax: 0.04,
        sku: "iopos.book.ref-dossier-esquematitzat-mossos-desquadra-2026",
        title: "Dossier Esquematitzat Mossos d'Esquadra 2026",
        name: "Dossier Esquematitzat Mossos d'Esquadra 2026",
        description: "Estudia millor, repassa més ràpid i aprova a la primera amb el dossier més visual dels Mossos.",
        enabled: true,
        stock: true,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos],
        price: 59.99,
        // offer: 59.99,
        // offer_text: "Últimes unitats!",
        shipment: 0.0,
        images: ["/611/image6"],
        banner: ["/611/image6"],
        link: "/tienda/libros/dossier-esquematitzat-mossos-desquadra-2026/",
        created_at: "2026-07-16 00:00:09",
        start_at: "2026-07-16 00:00:09",
        more_info: true,
        can_be_sent: true,
        items: 1,
        weight: 842,
    },
    // Pack Mossos Gold (2026)
    {
        id: 612,
        tax: 0.04,
        sku: "iopos.book.pack.mossos-gold-2026",
        title: "Pack Mossos Gold 2026",
        name: "Pack Mossos Gold 2026",
        description: "Vols la preparació més completa i efectiva? Amb el Pack Mossos Gold ho tens tot per estudiar amb estructura i arribar a la teva plaça amb confiança.",
        enabled: true,
        stock: true,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos, product_types_1.Category.Packs],
        price: 299.99,
        offer: 429.92,
        offer_text: "Estalvia diners amb els packs iOpos!",
        // recurrent: 'monthly',
        shipment: 4.49,
        images: ["/612/image4"],
        banner: ["/612/image4"],
        link: "/tienda/libros/pack-mossos-gold-2026",
        created_at: "2025-07-03 00:00:02",
        start_at: "2025-07-03 00:00:02",
        more_info: true,
        can_be_sent: true,
        items: 4,
        app: { modules: [1, 6, 96, 130], duration: 6 },
        discount_not_applicable: true,
        pack: true,
        pack_items: [453, 611, 901, 205],
        note: "Pack Mossos Gold (1001 + Dossier + Guia + Psicos)",
        weight: 2798,
        shipping_price: 6.99,
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (1 desembre)
    {
        id: 613,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2024-1-des",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (1 desembre)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (1 desembre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, Policies Locals i Guàrdia Urbana amb el nostre curs intensiu l'1 de desembre a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/613/image1"],
        banner: ["/613/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2024-1-desembre/",
        created_at: "2024-10-11 00:00:00",
        start_at: "2024-10-11 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [2012] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (21 desembre)
    {
        id: 614,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2024-21-des",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (21 desembre)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (21 desembre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, Policies Locals i Guàrdia Urbana amb el nostre curs intensiu el 21 de desembre a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/614/image1"],
        banner: ["/614/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2024-21-desembre/",
        created_at: "2024-10-22 00:00:00",
        start_at: "2024-10-22 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [2013] },
        can_be_sent: false,
        items: 1,
    },
    // Pack Mossos Essencial (Guia + Dossier) [2025/2026]
    {
        id: 615,
        tax: 0.04,
        sku: "iopos.book.pack.mossos-essencial-2026",
        title: "Pack Mossos Essencial (Guia + Dossier) 2026",
        name: "Pack Mossos Essencial (Guia + Dossier) 2026",
        description: "Aprofita el Pack Mossos Essencial i prepara't amb els materials clau per aprovar més ràpid, amb menys estrès i estalviant diners.",
        enabled: true,
        stock: true,
        stock_message: "Temporalment sense estoc.",
        type: product_types_1.Type.Book,
        price: 89.99,
        offer: 119.98,
        offer_text: "Estalvia 30 € amb aquest pack exclusiu!",
        category: [product_types_1.Category.Books, product_types_1.Category.Mossos, product_types_1.Category.Packs],
        shipment: 4.49,
        images: ["/615/image3"],
        banner: ["/615/image3"],
        link: "/tienda/libros/pack-mossos-essencial-guia-dossier-2026",
        created_at: "2025-06-30 00:00:09",
        start_at: "2025-06-30 00:00:09",
        more_info: true,
        can_be_sent: true,
        items: 2,
        pack: true,
        pack_items: [611, 453],
        discount_not_applicable: true,
        note: "Pack Mossos Essencial (Guia + Dossier)",
        weight: 1487,
        shipping_price: 5.99,
    },
    // Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M5] (Dissabtes 8:00 - 14 h, Novembre i Desembre)
    {
        id: 617,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "2024-open-me-curs-presencial-mossos-24-25-m5",
        title: "Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M5] (Dissabtes 8:00 - 14 h, Novembre i Desembre)",
        name: "Curs Intensiu Presencial Mossos d'Esquadra 24/25 [M5] (Dissabtes 8:00 - 14 h, Novembre i Desembre)",
        description: "Reserva la teva plaça per al curs intensiu de Mossos d'Esquadra, dissabtes nov. i des. de 8:00 a 14:00 h!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides.",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 231.99,
        offer: 289.99,
        offer_text: "Últimes places disponibles!",
        // offer: 189.99,
        // offer_text: "¡Pgit romo cursos presenciales y online",
        shipment: 0.0,
        images: ["/617/image3"],
        banner: ["/617/image3"],
        link: "/tienda/cursos/curs-presencial-mossos-esquadra-2024-25-m5-dissabtes-novembre-desembre/",
        created_at: "2024-10-31 00:00:01",
        start_at: "2024-10-31 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [1950] },
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (28 desembre)
    {
        id: 618,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2024-28-des",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (28 desembre)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2024 [8 hores] (28 desembre)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 28 de desembre a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/618/image1"],
        banner: ["/619/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2024-28-desembre/",
        created_at: "2024-11-07 00:00:00",
        start_at: "2024-11-07 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [2021] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (12 gener)
    {
        id: 620,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2025-12-gen",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (12 gener)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (12 gener)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 12 de gener a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/620/image1"],
        banner: ["/620/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2025-12-gener/",
        created_at: "2024-11-29 00:00:00",
        start_at: "2024-11-29 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [2027] },
        can_be_sent: false,
        items: 1,
    },
    // Zoom reforç exàmens 1er trimestre ISPC - Dret Constitucional (Dissabte 4 gener 18:00 h - 21:00 h)
    {
        id: 621,
        category: [product_types_1.Category.ISPC, product_types_1.Category.Online],
        tax: 0.21,
        sku: "iopos.course.online-curs-dret-constitucional-zoom-ispc-gen-2025",
        title: "Zoom reforç exàmens 1er trimestre ISPC - Dret Constitucional (Dissabte 4 gener 18:00 h - 21:00 h)",
        name: "Zoom reforç exàmens 1er trimestre ISPC - Dret Constitucional (Dissabte 4 gener 18:00 h - 21:00 h)",
        description: "Assolir l'Excel·lència en Dret Constitucional: El Curs Clau per Triomfar a l'Examen!",
        enabled: false,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 29.99,
        shipment: 0.0,
        images: ["/621/image1"],
        banner: ["/621/image1"],
        link: "/tienda/cursos/zoom-reforc-examens-1er-trimestre-ispc-dret-constitucional-4-gener-2025/",
        created_at: "2024-11-30 00:00:10",
        start_at: "2024-11-30 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 446, group_id: [2030] },
        can_be_sent: false,
        items: 1,
    },
    // Zoom reforç exàmens 1er trimestre ISPC - Dret Administratiu (Dissabte 28 des. 18:00 h - 21:00 h)
    {
        id: 622,
        category: [product_types_1.Category.ISPC, product_types_1.Category.Online],
        tax: 0.21,
        sku: "iopos.course.online-curs-dret-administratiu-zoom-ispc-des-2024",
        title: "Zoom reforç exàmens 1er trimestre ISPC - Dret Administratiu (Dissabte 28 des. 18:00 h - 21:00 h)",
        name: "Zoom reforç exàmens 1er trimestre ISPC - Dret Administratiu (Dissabte 28 des. 18:00 h - 21:00 h)",
        description: "Tot el que necessites saber de Dret Administratiu en només 3 hores per triomfar a l'examen de la 38a promoció!",
        enabled: false,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 29.99,
        shipment: 0.0,
        images: ["/622/image2"],
        banner: ["/622/image2"],
        link: "/tienda/cursos/zoom-reforc-examens-1er-trimestre-ispc-dret-adminstratiu-28-des-2024/",
        created_at: "2024-11-29 00:00:10",
        start_at: "2024-11-29 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 440, group_id: [2036] },
        can_be_sent: false,
        items: 1,
    },
    // Zoom reforç exàmens 1er trimestre ISPC - Drets Humans (Dissabte 11 gen. 18:00 h - 21:00 h)
    {
        id: 623,
        category: [product_types_1.Category.ISPC, product_types_1.Category.Online],
        tax: 0.21,
        sku: "iopos.course.online-curs-drets-humans-zoom-ispc-gen-2025",
        title: "Zoom reforç exàmens 1er trimestre ISPC - Drets Humans (Dissabte 11 gen. 18:00 h - 21:00 h)",
        name: "Zoom reforç exàmens 1er trimestre ISPC - Drets Humans (Dissabte 11 gen. 18:00 h - 21:00 h)",
        description: "Domina els Drets Humans amb el curs definitiu de 3 hores en directe: prepara't per triomfar a l'examen oficial!",
        enabled: false,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 29.99,
        shipment: 0.0,
        images: ["/623/image1"],
        banner: ["/623/image1"],
        link: "/tienda/cursos/zoom-reforc-examens-1er-trimestre-ispc-drets-humans-11-gen-2025/",
        created_at: "2024-11-30 00:00:10",
        start_at: "2024-11-30 00:00:10",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 510, group_id: [2033] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M4] (Dimarts i dijous 15:00 - 21 h, Gener - Febrer)
    {
        id: 624,
        tax: 0.21,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        sku: "2025-open-me-curs-presencial-mossos-24-25-m4-40h",
        title: "Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M4] (Dimarts i dijous 15:00 - 21 h, Gener - Febrer)",
        name: "Curs Intensiu (40 hores) Presencial Mossos d'Esquadra 24/25 [M4] (Dimarts i dijous 15:00 - 21 h, Gener - Febrer)",
        description: "Reserva la teva plaça per al curs intensiu Mossos d'Esquadra (40 hores), dimarts i dijous de gener i febrer de 15:00 a 21:00 h!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 349.99,
        // offer: 349.99,
        // offer_text: "Promoció Mossos només durant 24 hores!",
        shipment: 0.0,
        images: ["/624/image1"],
        banner: ["/624/image1"],
        link: "/tienda/cursos/curs-presencial-mossos-esquadra-2024-25-m4-40h/",
        created_at: "2024-12-02 00:00:02",
        start_at: "2024-12-02 00:00:02",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2039] },
    },
    // Tutorització CME 2025 (29 desembre 2024 - Reserva)
    {
        id: 625,
        tax: 0.0,
        sku: "iopos.course.classroom.tutoritzacio-cme-2025-29-des-reserva",
        title: "Tutorització CME 2025 (29 desembre 2024 - Reserva)",
        name: "Tutorització CME 2025 (29 desembre 2024 - Reserva)",
        hidden: true,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "Descobreix la nostra innovadora sessió de preparació personalitzada: 5 hores d'intens treball en grup, amb seguiment expert i resultats tangibles per afrontar amb èxit les oposicions!",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 14.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/616/image1"],
        banner: ["/616/image1"],
        link: "/tienda/cursos/tutoritzacio-cme-2025-29-desembre-reserva/",
        created_at: "2024-12-02 00:00:00",
        start_at: "2024-12-02 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 300,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        notify_emails: ["txema@iopos.academy"],
    },
    // Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (4 gener 2025)
    {
        id: 626,
        tax: 0.21,
        sku: "iopos.course.online.simulacre-temari-psicos-mossos-4-gen-2025",
        title: "Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (4 gener 2025)",
        name: "Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (4 gener 2025)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        description: "Comença el 2025 preparat i amb avantatge: participa en el simulacre de psicotècnics en directe més complet! Un entrenament realista amb temari i exercicis dissenyats per experts. Reserva la teva plaça i assoleix l'èxit!",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 24.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/626/image1"],
        banner: ["/626/image1"],
        link: "/tienda/cursos/simulacre-online-temari-psicos-mossos-4-gener-2025/",
        created_at: "2024-12-02 00:00:00",
        start_at: "2024-12-02 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 300,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        evolmind: { course_id: 443, group_id: [2042] },
    },
    // Masterclass Online Mossos d'Esquadra - Àmbit A (30 octubre 2025)
    {
        id: 627,
        tax: 0.21,
        sku: "iopos.course.online.mossos-masterclass-ambit-a-30-oct-2025",
        title: "Masterclass Online Mossos d'Esquadra - Àmbit A (30 octubre 2025)",
        name: "Masterclass Online Mossos d'Esquadra - Àmbit A (30 octubre 2025)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        description: "Prepara't per l'examen de Mossos d'Esquadra amb les nostres MÀSTER CLASS actualitzades. Aprèn en directe i accedeix a les gravacions fins al dia de la prova.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        // offer: 49.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/627/image1"],
        banner: ["/627/image1"],
        link: "/tienda/cursos/masterclass-online-mossos-ambit-a-30-octubre-2025/",
        created_at: "2025-09-17 00:00:01",
        start_at: "2025-09-17 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 466, group_id: [2045] },
    },
    // Masterclass Online Mossos d'Esquadra - Àmbit B (6 novembre 2025)
    {
        id: 628,
        tax: 0.21,
        sku: "iopos.course.online.mossos-masterclass-ambit-b-6-nov-2025",
        title: "Masterclass Online Mossos d'Esquadra - Àmbit B (6 novembre 2025)",
        name: "Masterclass Online Mossos d'Esquadra - Àmbit B (6 novembre 2025)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        description: "Prepara't per l'examen de Mossos d'Esquadra amb les nostres MÀSTER CLASS actualitzades. Aprèn en directe i accedeix a les gravacions fins al dia de la prova.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        // offer: 49.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/628/image1"],
        banner: ["/628/image1"],
        link: "/tienda/cursos/masterclass-online-mossos-ambit-b-6-novembre-2025/",
        created_at: "2025-09-17 00:00:00",
        start_at: "2025-09-17 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 463, group_id: [2048] },
    },
    // Masterclass Online Mossos d'Esquadra - Àmbit C (13 novembre 2025)
    {
        id: 629,
        tax: 0.21,
        sku: "iopos.course.online.mossos-masterclass-ambit-c-13-nov-2025",
        title: "Masterclass Online Mossos d'Esquadra - Àmbit C (13 novembre 2025)",
        name: "Masterclass Online Mossos d'Esquadra - Àmbit C (13 novembre 2025)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online],
        description: "Prepara't per l'examen de Mossos d'Esquadra amb les nostres MÀSTER CLASS actualitzades. Aprèn en directe i accedeix a les gravacions fins al dia de la prova.",
        enabled: false,
        stock: false,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        // offer: 49.99,
        // offer_text: "Oferta durant les pròximes 24 hores!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/629/image1"],
        banner: ["/629/image1"],
        link: "/tienda/cursos/masterclass-online-mossos-ambit-c-13-nov-2025/",
        created_at: "2025-09-17 00:00:00",
        start_at: "2025-09-17 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 457, group_id: [2051] },
    },
    // Last Week of Mossos 2025 (1 febrer - 10 hores)
    {
        id: 630,
        tax: 0.0,
        sku: "iopos.course.classroom.last-week-mossos-1-feb-2025",
        title: "Last Week of Mossos 2025 (1 febrer - 10 hores)",
        name: "Last Week of Mossos 2025 (1 febrer - 10 hores)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "Prepara't per triomfar a l'examen de Mossos 2025 amb el curs intensiu que marca la diferència. Últim esforç, màxim resultat!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 109.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/630/image1"],
        banner: ["/630/image1"],
        link: "/tienda/cursos/last-of-week-mossos-2025-1-febrer/",
        created_at: "2024-12-09 00:00:00",
        start_at: "2024-12-09 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        limit: 30,
        items: 1,
        evolmind: { course_id: 349, group_id: [2054] },
    },
    // Last Week of Mossos 2025 (2 febrer - 10 hores)
    {
        id: 631,
        tax: 0.0,
        sku: "iopos.course.classroom.last-week-mossos-2-feb-2025",
        title: "Last Week of Mossos 2025 (2 febrer - 10 hores)",
        name: "Last Week of Mossos 2025 (2 febrer - 10 hores)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "Prepara't per triomfar a l'examen de Mossos 2025 amb el curs intensiu que marca la diferència. Últim esforç, màxim resultat!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 109.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/631/image1"],
        banner: ["/631/image1"],
        link: "/tienda/cursos/last-of-week-mossos-2025-2-febrer/",
        created_at: "2024-12-09 00:00:00",
        start_at: "2024-12-09 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2057] },
    },
    // Last Week of Mossos 2025 (8 febrer - 10 hores)
    {
        id: 632,
        tax: 0.0,
        sku: "iopos.course.classroom.last-week-mossos-8-feb-2025",
        title: "Last Week of Mossos 2025 (8 febrer - 10 hores)",
        name: "Last Week of Mossos 2025 (8 febrer - 10 hores)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "Prepara't per triomfar a l'examen de Mossos 2025 amb el curs intensiu que marca la diferència. Últim esforç, màxim resultat!",
        enabled: false,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 109.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/632/image1"],
        banner: ["/632/image1"],
        link: "/tienda/cursos/last-of-week-mossos-2025-8-febrer/",
        created_at: "2024-12-09 00:00:00",
        start_at: "2024-12-09 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2063] },
    },
    // Last Week of Mossos 2025 (9 febrer - 10 hores)
    {
        id: 633,
        tax: 0.0,
        sku: "iopos.course.classroom.last-week-mossos-9-feb-2025",
        title: "Last Week of Mossos 2025 (9 febrer - 10 hores)",
        name: "Last Week of Mossos 2025 (9 febrer - 10 hores)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "Prepara't per triomfar a l'examen de Mossos 2025 amb el curs intensiu que marca la diferència. Últim esforç, màxim resultat!",
        enabled: false,
        stock: false,
        stock_message: "No disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 109.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/633/image1"],
        banner: ["/633/image1"],
        link: "/tienda/cursos/last-of-week-mossos-2025-9-febrer/",
        created_at: "2024-12-09 00:00:00",
        start_at: "2024-12-09 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        limit: 30,
        evolmind: { course_id: 349, group_id: [2060] },
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (19 gener)
    {
        id: 634,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2025-19-gen",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (19 gener)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (19 gener)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 19 de gener a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/634/image1"],
        banner: ["/634/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2025-19-gener/",
        created_at: "2024-12-09 00:00:00",
        start_at: "2024-12-09 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [2066] },
        can_be_sent: false,
        items: 1,
    },
    // Curs de Psicotècnics en directe (12 h a través de Zoom - Gen/Feb 2025)
    {
        id: 635,
        tax: 0.21,
        sku: "iopos.course.classroom.ref-2020-116-psicos-en-directe-zoom-12-h-gen-feb-2025",
        title: "Curs de Psicotècnics en directe (12 h a través de Zoom - Gen/Feb 2025)",
        name: "Curs de Psicotècnics en directe (12 h a través de Zoom - Gen/Feb 2025)",
        description: "Transforma el teu futur amb el nostre curs intensiu de psicos: 12 hores de formació en directe, exercicis nous i tot el suport que necessites per dominar la prova i garantir el teu èxit.",
        enabled: false,
        stock: false,
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 59.99,
        offer: 99.99,
        offer_text: "12 hores de psicos et separen de l'apte!",
        shipment: 0.0,
        images: ["/635/image1"],
        banner: ["/635/image1"],
        link: "/tienda/cursos/curs-psicotecnics-en-directe-zoom-12-hores-zoom-gener-febrer-2025/",
        created_at: "2024-12-12 00:00:02",
        start_at: "2024-12-12 00:00:02",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        evolmind: { course_id: 72, group_id: [2069] },
        can_be_sent: false,
        items: 1,
    },
    // Pack 3 Mossos - Preparació Online Tests Psicoprofessionals 2026
    {
        id: 636,
        tax: 0.21,
        sku: "iopos.course.online.pack3-sessions-preparacio-online-tests-psico-2026",
        title: "Pack 3 Sessions- Preparación Online Tests Psicoprofessionals 2026",
        name: "Pack 3 Sessions - Preparación Online Tests Psicoprofessionals 2026",
        description: "Descobreix el teu perfil policial i prepara't amb garanties per a les oposicions de Mossos d'Esquadra, Guàrdia Urbana o Policies Locals amb el nostre servei personalitzat d'anàlisi psicològica. Reserva ara i obté la teva gràfica personalitzada amb orientació experta a través de Zoom!",
        enabled: true,
        stock: true,
        category: [product_types_1.Category.Psicos, product_types_1.Category.Online],
        stock_message: "Aviat disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 199.99,
        shipment: 0.0,
        images: ["/636/image3"],
        banner: ["/636/image3"],
        link: "/tienda/cursos/pack-3-sessions-preparacio-online-tests-psicoprofessionals-2026/",
        created_at: "2026-06-11 00:00:01",
        start_at: "2026-06-11 00:00:01",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        notify_emails: ["testpsicos@iopos.academy"],
        discount_not_applicable: true,
        evolmind: { course_id: 1306, group_id: [3244] },
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (26 gener)
    {
        id: 637,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2025-26-gen",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (26 gener)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (26 gener)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 26 de gener a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/637/image1"],
        banner: ["/637/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2025-26-gener/",
        created_at: "2024-12-18 00:00:00",
        start_at: "2024-12-18 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 32,
        evolmind: { course_id: 355, group_id: [2072] },
        can_be_sent: false,
        items: 1,
    },
    // Tutorització CME 2025 (18 gener 2025 - Reserva)
    {
        id: 638,
        tax: 0.0,
        sku: "iopos.course.classroom.tutoritzacio-cme-2025-18-gen-reserva",
        title: "Tutorització CME 2025 (18 gener 2025 - Reserva)",
        name: "Tutorització CME 2025 (18 gener 2025 - Reserva)",
        hidden: true,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "Descobreix la nostra innovadora sessió de preparació personalitzada: 5 hores d'intens treball en grup, amb seguiment expert i resultats tangibles per afrontar amb èxit les oposicions!",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 14.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/638/image1"],
        banner: ["/638/image1"],
        link: "/tienda/cursos/tutoritzacio-cme-2025-18-gener-reserva/",
        created_at: "2024-12-18 00:00:00",
        start_at: "2024-12-18 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 50,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        notify_emails: ["txema@iopos.academy"],
    },
    // Tutorització CME 2025 (2 febrer 2025 - Reserva)
    {
        id: 639,
        tax: 0.0,
        sku: "iopos.course.classroom.tutoritzacio-cme-2025-2-feb-reserva",
        title: "Tutorització CME 2025 (2 febrer 2025 - Reserva)",
        name: "Tutorització CME 2025 (2 febrer 2025 - Reserva)",
        hidden: true,
        category: [product_types_1.Category.Mossos, product_types_1.Category.FaceToFace],
        description: "Descobreix la nostra innovadora sessió de preparació personalitzada: 5 hores d'intens treball en grup, amb seguiment expert i resultats tangibles per afrontar amb èxit les oposicions!",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 14.99,
        shipment: 0.0,
        images: ["/639/image1"],
        banner: ["/639/image1"],
        link: "/tienda/cursos/tutoritzacio-cme-2025-2-de-febrer-reserva/",
        created_at: "2025-01-04 00:00:00",
        start_at: "2025-01-04 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 50,
        can_be_sent: false,
        items: 1,
        discount_not_applicable: true,
        notify_emails: ["txema@iopos.academy"],
    },
    // Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (24 novembre 2025)
    {
        id: 640,
        tax: 0.21,
        sku: "iopos.course.online.simulacre-temari-psicos-mossos-24-novembre-2025",
        title: "Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (24 novembre 2025)",
        name: "Simulacre Online Temari i Psicotècnics Mossos d'Esquadra (24 novembre 2025)",
        category: [product_types_1.Category.Mossos, product_types_1.Category.Online, product_types_1.Category.Psicos],
        description: "Entrena com si fos l'examen real i arriba amb avantatge al dia oficial: el simulacre més complet per superar els psicotècnics dels Mossos.",
        enabled: true,
        stock: true,
        stock_message: "No disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Online,
        price: 49.99,
        shipment: 0.0,
        images: ["/951/image1"],
        banner: ["/951/image1"],
        link: "/tienda/cursos/simulacre-online-temari-psicos-mossos-24-novembre-2025/",
        created_at: "2025-11-01 00:00:00",
        start_at: "2025-11-01 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        evolmind: { course_id: 443, group_id: [2695] },
        parent: 951,
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (8 febrer)
    {
        id: 641,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2025-8-feb",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (29 juny)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (29 juny)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 8 de febrer a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/641/image2"],
        banner: ["/641/image2"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2025-8-febrer/",
        created_at: "2025-05-28 00:00:00",
        start_at: "2025-05-28 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 36,
        evolmind: { course_id: 355, group_id: [2081] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (31 gener)
    {
        id: 642,
        tax: 0.0,
        hidden: true,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2025-31-gen",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (31 gener)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (31 gener)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 31 de gener a l'Hospitalet!",
        enabled: true,
        stock: true,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/642/image1"],
        banner: ["/642/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2025-31-gen/",
        created_at: "2025-01-08 00:00:00",
        start_at: "2025-01-08 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [2084] },
        can_be_sent: false,
        items: 1,
    },
    // 643. Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (14 febrer)
    {
        id: 643,
        tax: 0.0,
        sku: "iopos.course.classroom.psicos-aptitudinals-gub-2025-14-feb",
        title: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (14 febrer)",
        name: "Curs Presencial de Psicotècnics Aptitudinals 2025 [8 hores] (14 febrer)",
        category: [product_types_1.Category.Psicos, product_types_1.Category.FaceToFace],
        description: "Prepara't pels psicotècnics de Mossos, policies locals i Guàrdia Urbana amb el nostre curs intensiu el 14 de febrer a l'Hospitalet!",
        enabled: false,
        stock: false,
        stock_message: "Sense places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        // offer: 99.99,
        // offer_text: "¡Enamórate de iOpos!",
        // recurrent: 'monthly',
        shipment: 0.0,
        images: ["/643/image1"],
        banner: ["/643/image1"],
        link: "/tienda/cursos/curs-presencial-psicos-aptitudinals-2025-14-feb/",
        created_at: "2025-01-13 00:00:00",
        start_at: "2025-01-13 00:00:00",
        more_info: true,
        release: true,
        release_message: "¡Nuevo Curso!",
        limit: 30,
        evolmind: { course_id: 355, group_id: [2087] },
        can_be_sent: false,
        items: 1,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 (5 hores)
    {
        id: 650,
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
            product_types_1.Category.FASE1,
        ],
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-prep-ade-psico-biodata-mossos-25",
        title: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 (5 hores)",
        name: "Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 (5 hores)",
        description: "Prepara't per superar la 3a prova d'accés als Mossos d'Esquadra amb el curs més complet i personalitzat!",
        enabled: false,
        stock: false,
        stock_message: "Actualment sense horaris disponibles.",
        low_stock_message: "Últimes places disponibles!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image1"],
        banner: ["/650/image1"],
        link: "/tienda/cursos/curs-preparacio-tercera-prova-mossos-2025/",
        // ,
        created_at: "2025-04-01 00:00:01",
        start_at: "2025-04-01 00:00:01",
        more_info: false,
        // release: false,
        // release_message: "¡Nuevo Curso!",
        can_be_sent: false,
        items: 1,
        /*childs: [
                651, 652, 653, 654, 655, 656, 657, 658, 659, 660, 661, 662, 663, 664, 665, 666, 680,
                686, 700, 699,
            ],*/
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 651,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-15-marc-09-14",
        title: "3a prova Mossos 2025 - 15 març 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 15 març 09:00 a 14:00 h",
        short: "1.) 3a prova Mossos 2025 - 15 març 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "Places exhaurides!",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2114], limit: 35 },
        can_be_sent: false,
        items: 1,
        default_in_parent: true,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 652,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-15-marc-15-20",
        title: "3a prova Mossos 2025 - 15 març 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 15 març 15:00 a 20:00 h",
        short: "2.) 3a prova Mossos 2025 - 15 març 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2117], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 653,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-16-marc-09-14",
        title: "3a prova Mossos 2025 - 16 març 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 16 març 09:00 a 14:00 h",
        short: "3.) 3a prova Mossos 2025 - 16 març 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2120], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 654,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-15-marc-16-20",
        title: "3a prova Mossos 2025 - 16 març 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 16 març 15:00 a 20:00 h",
        short: "4.) 3a prova Mossos 2025 - 16 març 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2123], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 655,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-22-marc-09-14",
        title: "3a prova Mossos 2025 - 22 març 09:00 a 14:00 h",
        name: "3a prova Mossos 2025 - 22 març 09:00 a 14:00 h",
        short: "5.) 3a prova Mossos 2025 - 22 març 09 a 14 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2126], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
    // Curs Presencial Preparació Tercera Prova Mossos d'Esquadra 2025 - Sessions
    {
        id: 656,
        tax: 0.0,
        sku: "iopos.course.f2f.ref-2023-067-curs-3a-prova-mossos-25-22-marc-16-20",
        title: "3a prova Mossos 2025 - 22 març 15:00 a 20:00 h",
        name: "3a prova Mossos 2025 - 22 març 15:00 a 20:00 h",
        short: "6.) 3a prova Mossos 2025 - 22 març 15 a 20 h",
        category: [
            product_types_1.Category.FaceToFace,
            product_types_1.Category.Psicos,
            product_types_1.Category.Mossos,
            product_types_1.Category.Interviews,
        ],
        description: "",
        enabled: false,
        stock: false,
        stock_message: "En breu disponible",
        type: product_types_1.Type.Course,
        subtype: product_types_1.Subtype.Classroom,
        price: 99.99,
        shipment: 0.0,
        images: ["/650/image3"],
        created_at: "2025-01-15 00:00:10",
        start_at: "2025-01-15 00:00:10",
        more_info: false,
        evolmind: { course_id: 57, group_id: [2129], limit: 35 },
        can_be_sent: false,
        items: 1,
        parent: 650,
    },
];
exports.default = products;
